import classNames from 'classnames';
import { formatLocalDateTime, FullPost } from 'model';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { RootState } from '../App';
import GenericEventIcon from '../assets/eventDefault.png';
import { LoginState } from '../state/loginSlice';
// styles
import styles from './EventCalendarItem.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { EventDateBadgeOutput } from '../util/eventCalendarDateBadge';
import { AuthorHeaderEventItem } from './AuthorHeaderEventItem';
import { DateBadge } from './DateBadge';
import { IconThumbsUp } from './QuirkIcons';
import { useBackendImageURL } from '../hooks/useBackendDomain.js';

export const EventCalendarItem: React.FC<{
	post: FullPost;
	interested: number;
	lastItem: boolean;
	eventDateBadge: EventDateBadgeOutput;
}> = ({ post, interested, eventDateBadge, lastItem }) => {
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	const { _id: userid } = state.user;

	const getBackgroundImage = () => {
		const image = post?.images?.[0] && `/api/post/image/${post._id}/${post?.images?.[0]}`;
		const linkPreviewImage = post?.linkPreview?.image;
		if (image) {
			return image;
		} else if (linkPreviewImage) {
			return linkPreviewImage;
		} else {
			return GenericEventIcon;
		}
	};
	const backgroundImageUrl = useBackendImageURL(getBackgroundImage());

	return (
		<>
			{post.postType === 'event' && (
				<NavLink to={`/main/latest/post/show/${post._id}`} className="nounderline">
					<div className={styles.outer}>
						<div className={styles.dateContainer}>
							<DateBadge eventDateBadge={eventDateBadge} />
						</div>
						<div
							className={classNames(styles.container, lastItem && styles.lastItem)}
							style={{
								background:
									post.author === userid ? 'var(--ion-color-success-highlight)' : 'transparent'
							}}
						>
							<div>
								<div>
									<div className={styles.title}>{post?.title}</div>
									<div className={styles.time}>{formatLocalDateTime(post.eventDate)}</div>
								</div>
								<div className={styles.authorContainer}>
									<AuthorHeaderEventItem authoredItem={post} />
								</div>
							</div>
						</div>
						<div
							className={classNames(styles.eventImageContainer, lastItem && styles.lastItem)}
							style={{
								background:
									post.author === userid ? 'var(--ion-color-success-highlight)' : 'transparent'
							}}
						>
							<div
								className={styles.eventImage}
								style={{
									backgroundImage: `url(${backgroundImageUrl})`
								}}
							>
								{interested > 0 && (
									<div className={styles.interestedContainer}>
										<div
											className={classNames(
												sharedStyles.contrastColor,
												sharedStyles.controlIcon,
												styles.interestedIcon
											)}
										>
											<IconThumbsUp />
										</div>
										<div className={styles.interestedNumber}> {interested} </div>
									</div>
								)}
							</div>
						</div>
					</div>
				</NavLink>
			)}
		</>
	);
};
